<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('fe_parts.create')" @invoke-method="invokeMethod($event)" action="openFePartForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetFeParts(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <bc-autocomplete
                                            class="horizontal-scroll"
                                            v-model="filter.tag"
                                            :items="fe_part_categories || []"
                                            item-value="category_id"
                                            item-text="category_name"
                                            label="Categories"
                                            multiple
                                            small-chips
                                            deletable-chips
                                        ></bc-autocomplete>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.exact_match"
                                                color="success"
                                                :label="$t('lang.exact_match')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="fe_parts" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openFePartForm(props.item)">
                                <td>{{ props.item.sales_sku }}</td>
                                <td>{{ props.item.name }}</td>
                                <td>{{ props.item.model_number }}</td>
                                <td>{{ props.item.sales_description }}</td>
                                <td>
                                    {{ props.item.stock_quantity != null ? props.item.stock_quantity : 0 }}
                                </td>
                                <td>
                                    {{ props.item.order_quantity != null ? props.item.order_quantity : 0 }}
                                </td>
                                <td>
                                    <v-chip round text-color="white" class="mr-auto fs-14" :color="props.item.status_class">
                                        <span class="white--text">{{ props.item.active == "1" ? $t("lang.active") : $t("lang.inactive") }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="fe_parts"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="fe_part_dialog">
                <v-card>
                    <v-form ref="form_fe_part">
                        <v-card-title>
                            <span class="headline">{{ fe_part.part_id ? $t("lang.edit_fe_part") : $t("lang.add_fe_part") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeFePartDialog"
                                :dialog-status="fe_part_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="fe_part_dialog"
                                            v-model="fe_part.part_id"
                                            :label="$t('lang.part_id')"
                                            :counter="showCounter(fe_part.part_id, 'fe_parts.part_id')"
                                            :rules="ifValid('fe_parts.part_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="fe_part.name"
                                            :label="`${$t('lang.name')} *`"
                                            :counter="showCounter(fe_part.name, 'fe_parts.name')"
                                            :rules="ifValid('fe_parts.name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="fe_part.model_number"
                                            :label="`${$t('lang.model_number')} *`"
                                            :counter="showCounter(fe_part.model_number, 'fe_parts.model_number')"
                                            :rules="ifValid('fe_parts.model_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="fe_part.lead_time"
                                            :label="$t('lang.lead_time')"
                                            :counter="showCounter(fe_part.lead_time, 'fe_parts.lead_time')"
                                            :rules="ifValid('fe_parts.lead_time')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="fe_part.weight_pounds"
                                            :label="`${$t('lang.weight_pounds')} *`"
                                            :counter="showCounter(fe_part.weight_pounds, 'fe_parts.weight_pounds')"
                                            :rules="ifValid('fe_parts.weight_pounds')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="fe_part.sales_price"
                                            :label="`${$t('lang.sales_price')} *`"
                                            :counter="showCounter(fe_part.sales_price, 'fe_parts.sales_price')"
                                            :rules="ifValid('fe_parts.sales_price')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="fe_part.sales_unit"
                                            :label="`${$t('lang.sales_unit')} *`"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('fe_parts.sales_unit')"
                                        ></bc-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="fe_part.part_cost"
                                            :label="`${$t('lang.part_cost')} *`"
                                            :counter="showCounter(fe_part.part_cost, 'fe_parts.part_cost')"
                                            :rules="ifValid('fe_parts.part_cost')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="fe_part.active"
                                            :label="$t('lang.active')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('fe_parts.active')"
                                        ></bc-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="fe_part.part_id" color="error" @mouseup.left="$refs.delete_fe_parts.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeFePartDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveFeParts">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_fe_parts"
                :heading="$t('lang.delete_fe_part')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteFeParts(fe_part.part_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openFePartForm" },
                { title: this.$t("lang.refresh"), action: "dbGetFeParts", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.sales_sku"), sortable: false, width: "7%" },
                { text: this.$t("lang.name"), sortable: false, width: "7%" },
                { text: this.$t("lang.model_number"), sortable: false, width: "7%" },
                { text: this.$t("lang.sales_description"), sortable: false, width: "21%" },
                // { text: this.$t("lang.lead_time"), sortable: false, width: "7%" },
                // { text: this.$t("lang.sales_price"), sortable: false, width: "7%" },
                // { text: this.$t("lang.sales_unit"), sortable: false, width: "7%" },
                { text: `${this.$t("lang.on_hand")}`, sortable: false, width: "7%" },
                { text: `${this.$t("lang.on_order")}`, sortable: false, width: "7%" },
                { text: this.$t("lang.active"), sortable: false, width: "7%" },
            ],
            enableAddModal: false,
            enableEditModal: false,

            fe_part: {},
            filter: {
                search: "",
                exact_match: "0",
                tag: null,
            },
            fe_part_dialog: false,
            dbGetFeParts: _.debounce(this.getFeParts, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchFeParts", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.fe_parts) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchFeParts({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.fe_parts) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.fe_parts.fe_parts_filter,
            page: (state) => state.fe_parts.page,
            rules_fe_parts: (state) => state.fe_parts.rules_fe_parts,
            fe_part_status_options: (state) => state.settings.fe_part_status_options,
            fe_parts: (state) => state.fe_parts.fe_parts,
            fe_part_categories: (state) => state.fe_part_categories.fe_part_category_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchFeParts", "saveFePart", "deleteFePart", "fetchFePartCategories"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openFePartForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_fe_part) item ? this.$refs.form_fe_part.resetValidation() : this.$refs.form_fe_part.reset();

                    this.$nextTick(() => {
                        this.fe_part = item != null ? this.assignObj2(item, this.rules_fe_parts) : {};
                        this.fe_part_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "fe_part", params: { id: item.part_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_fe_part) item ? this.$refs.form_fe_part.resetValidation() : this.$refs.form_fe_part.reset();
                    this.fe_part_dialog = true;
                } else {
                    this.$router.push({ name: "fe_part" });
                }
            }
        },
        saveFeParts() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_fe_part")) {
                    let body = this.prepForm(this.fe_part, this.rules_fe_parts);

                    this.saveFePart({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getFeParts();
                                this.closeFePartDialog();
                            } else {
                                this.$router.push({ name: "fe_part", params: { id: data.part_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteFeParts(id = null) {
            this.deleteFePart({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getFeParts();
                    this.closeFePartDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeFePartDialog() {
            this.fe_part_dialog = false;
            this.$refs.delete_fe_parts.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getFeParts(pg_refresh = false) {
            this.startLoader();

            this.fetchFeParts({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.fe_part_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            if (this.fe_part_categories.length == 0 || force == true) await this.fetchFePartCategories({ body: { options: 1 } });
        },
    },
    mounted() {
        this.refresh();
    },
};
</script>
<style>
.horizontal-scroll .v-select__selections {
    overflow-x: auto;
    flex-wrap: nowrap;
}
.horizontal-scroll {
    width: 100px;
}
</style>
